export enum Role {
  Dealer = 'dealer',
  User = 'user'
}

export interface User {
  id: string;
  name: string;
  fullName: string;
  email: string;
  avatarSrc?: string;
  role: Role;
  accidentInProgress?: number;
  statementsDataGrid?: string;
  avgPhmPrices?: Record<string, Record<string, number>>;
  phmLiters?: Record<string, Record<string, number>>;
}
